import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative bg-secondary-light px-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cursor-move absolute space-y-1.5 handle top-3 left-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400" })
], -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "italic" }
const _hoisted_7 = { class: "text-xs py-1.5" }

import { computed, inject, ref, Ref } from 'vue';
import SlideUpDown from 'vue3-slide-up-down';
import { v4 } from 'uuid';
import { useVModels } from '@vueuse/core';

interface Props {
  title: string;
  subtitle: string;
  thirdTitle: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    subtitle: null,
    thirdTitle: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  title: string;
  subtitle: string;
  thirdTitle: string;
}

const uuid = ref(v4());

const open = inject<Ref<string>>('open');

const visible = computed(() => uuid.value === open?.value);

const titleLabel = computed(() => {
  if (titleModel.value) {
    return titleModel.value;
  }

  return 'TITLE';
});

const subtitleLabel = computed(() => {
  if (subTitleModel.value) {
    return subTitleModel.value;
  }

  if (titleModel.value) {
    return '';
  }

  return 'NOT';
});

const thirdTitleLabel = computed(() => {
  if (thirdTitleModel.value) {
    return thirdTitleModel.value;
  }

  if (titleModel.value) {
    return '';
  }

  return 'SET';
});

function toggle() {
  if (open) {
    if (open.value === uuid.value) {
      open.value = '';
    } else {
      open.value = uuid.value;
    }
  }
}



const {
  title: titleModel,
  subtitle: subTitleModel,
  thirdTitle: thirdTitleModel,
} = useVModels(props);

expose({ sectionUuid: uuid.value });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_unref(visible))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "flex py-3 cursor-pointer select-none gap-x-1",
            onClick: _withModifiers(toggle, ["self"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(titleModel) ? (titleModel).value = $event : null)),
                placeholder: "Bold title"
              }, null, 512), [
                [_vModelText, _unref(titleModel)]
              ])
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(subTitleModel) ? (subTitleModel).value = $event : null)),
                placeholder: "Normal title"
              }, null, 512), [
                [_vModelText, _unref(subTitleModel)]
              ])
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(thirdTitleModel) ? (thirdTitleModel).value = $event : null)),
                placeholder: "Italic title"
              }, null, 512), [
                [_vModelText, _unref(thirdTitleModel)]
              ])
            ])
          ], 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "flex py-3 cursor-pointer select-none gap-x-1",
            onClick: toggle
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(titleLabel)), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(subtitleLabel)), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(thirdTitleLabel)), 1)
          ])),
      (_ctx.$slots.info)
        ? (_openBlock(), _createBlock(_unref(SlideUpDown), {
            key: 2,
            modelValue: _unref(visible),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "info")
              ])
            ]),
            _: 3
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(SlideUpDown), {
      modelValue: _unref(visible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}
}

})